import React, { useEffect } from 'react';
import { useRouteError } from 'react-router-dom';
import { Box, Button, Typography } from '@mui/material';

export default function ApplicationError() {
  const error = useRouteError();
  useEffect(() => {
    console.error('Decode page failed:', error);
  }, [error]);

  return (
    <Box role="alert" sx={{ minHeight: '100vh', p: 3, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 2 }}>
      <Typography variant="h4">Decode couldn’t display this page</Typography>
      <Typography color="text.secondary">Reload the page to try again.</Typography>
      <Button variant="contained" onClick={() => window.location.reload()}>Reload page</Button>
    </Box>
  );
}
